import { useMsal } from "@azure/msal-react";
import { useState } from "react";

import { loginRequest } from "@/lib/auth";

export function LoginPage() {
  const { instance } = useMsal();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const handleLogin = async () => {
    setError(null);
    setBusy(true);
    try {
      await instance.loginPopup(loginRequest);
      // Después del popup exitoso, useIsAuthenticated en App.tsx rerenderiza.
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-full flex items-center justify-center bg-slate-50 px-4">
      <div className="max-w-md w-full bg-white border rounded-lg shadow-sm p-8 text-center">
        <img src="/logo-mark.png" alt="MPP Energía" className="w-14 h-14 mx-auto mb-4" />
        <h1 className="text-2xl font-semibold text-slate-900 mb-2">
          Portal Estados de Cuenta
        </h1>
        <p className="text-sm text-slate-500 mb-6">CENACE · MPP Energía</p>

        <button
          type="button"
          onClick={handleLogin}
          disabled={busy}
          className="w-full inline-flex items-center justify-center gap-2 bg-slate-900 text-white font-medium rounded-md px-4 py-2.5 hover:bg-slate-800 disabled:opacity-50"
        >
          <MicrosoftIcon />
          {busy ? "Conectando…" : "Iniciar sesión con Microsoft"}
        </button>

        <p className="text-xs text-slate-400 mt-6">
          Solo cuentas <span className="font-medium">@mppenergia.com</span> y{" "}
          <span className="font-medium">@panterainfra.com</span>.
        </p>

        {error && (
          <div className="mt-4 text-sm text-red-600 bg-red-50 border border-red-200 rounded px-3 py-2 text-left">
            {error}
          </div>
        )}
      </div>
    </div>
  );
}

function MicrosoftIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 23 23" aria-hidden="true">
      <rect x="1" y="1" width="10" height="10" fill="#F35325" />
      <rect x="12" y="1" width="10" height="10" fill="#81BC06" />
      <rect x="1" y="12" width="10" height="10" fill="#05A6F0" />
      <rect x="12" y="12" width="10" height="10" fill="#FFBA08" />
    </svg>
  );
}
